import React, { FC } from 'react';
import { Icons } from '../Icon';
import * as SC from './styled';
import { ScoreSize } from './styled';
export enum Scores {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
}
export const icons = {
  [Scores.A]: Icons.scoreA,
  [Scores.B]: Icons.scoreB,
  [Scores.C]: Icons.scoreC,
  [Scores.D]: Icons.scoreD,
  [Scores.E]: Icons.scoreE
};
export const iconsV2 = {
  [Scores.A]: Icons.scoreAv2,
  [Scores.B]: Icons.scoreBv2,
  [Scores.C]: Icons.scoreCv2,
  [Scores.D]: Icons.scoreDv2,
  [Scores.E]: Icons.scoreEv2
};
export type ScoreProps = {
  className?: string;
  value?: Scores;
  size?: ScoreSize;
  isV2?: boolean;
};
const Score: FC<ScoreProps> = ({
  className,
  value,
  size,
  isV2
}) => {
  const icon = (isV2 ? iconsV2 : icons)?.[value ?? Scores.A] ?? icons[Scores.A];
  return <SC.Score className={className} $size={size}>
      <SC.ScoreIcon icon={icon} />
    </SC.Score>;
};
export default Score;